
import { TaxonomyLevel } from "@/types/supabase";

export const reflectionPrompts: Record<TaxonomyLevel, string> = {
  remember: "What are the key concepts you've learned in this lesson? List them and provide a brief description of each.",
  understand: "Explain the main ideas of this lesson in your own words. How would you describe what you've learned to someone else?",
  apply: "Think about a real-world situation where you could apply what you've learned. How would you use these concepts to solve a problem?",
  analyze: "Analyze the relationships between the different concepts covered in this lesson. How do they connect to each other?",
  evaluate: "Evaluate the strengths and limitations of the approaches described in this lesson. What works well and what could be improved?",
  create: "How could you extend or combine the ideas in this lesson to create something new? Describe your innovation."
};

export const taxonomyColors: Record<TaxonomyLevel, string> = {
  remember: 'text-slate-600',
  understand: 'text-blue-600',
  apply: 'text-green-600',
  analyze: 'text-yellow-600',
  evaluate: 'text-orange-600',
  create: 'text-red-600'
};
